import React from "react";
import "./especialistaPicker.css";

const abreviarNome = (nome) => {
  const partes = nome.split(" ");
  if (partes.length <= 2) return nome;

  const primeiro = partes[0];
  const ultimo = partes[partes.length - 1];
  const meio = partes.slice(1, -1).map((p) => p[0].toUpperCase() + ".");
  return [primeiro, ...meio, ultimo].join(" ");
};

const EspecialistaPicker = ({ colaboradores, agendamento, onSelect }) => {
  return (
    <div className="especialistas-container" style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
      {colaboradores.map((colab) => {
        const selected = agendamento.colaboradorId === colab._id;

        return (
          <div
            key={colab._id}
            onClick={() => onSelect(colab._id)}
            style={{
              width: "120px",
              border: selected ? "2px solid #003D42" : "2px solid transparent",
              borderRadius: "10px",
              cursor: "pointer",
              padding: "5px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              transition: "0.2s all",
            }}
          >
            <img
              src={colab.foto || "https://www.gravatar.com/avatar/?d=mp&s=200"}
              alt={colab.nome}
              style={{
                width: "80px",
                height: "80px",
                objectFit: "cover",
                borderRadius: "50%",
                marginBottom: "5px",
              }}
            />
            <h1
              style={{
                fontSize: "14px",
                textAlign: "center",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "100%",
              }}
              title={colab.nome}
            >
              {abreviarNome(colab.nome)}
            </h1>
          </div>
        );
      })}
    </div>
  );
};

export default EspecialistaPicker;
